// iPad/tablet browsers treat a double tap as zoom and seldom send dblclick, so report
// grids (single click selects, double click opens) never opened a record by touch.
// AG Grid only emulates it on iOS when dblclick is unsupported, which Safari reports it is.
export const REPORT_DOUBLE_TAP_MS = 400;
// The browser may still send dblclick shortly after a double tap opened the record.
const DBLCLICK_AFTER_TAP_MS = 1000;

export function createReportDoubleTap(now = () => Date.now()) {
  let pointerType = "mouse";
  let lastTap = { rowId: null, at: 0 };
  let openedAt = -Infinity;
  return {
    pointerDown(type) {
      pointerType = type;
    },
    // True for the second touch tap on the same row within REPORT_DOUBLE_TAP_MS, unless the
    // grid has turned "double-click opens record" off.
    opensRecord(rowId, enabled) {
      if (!enabled || pointerType !== "touch") return false;
      const at = now();
      if (rowId != null && lastTap.rowId === rowId && at - lastTap.at < REPORT_DOUBLE_TAP_MS) {
        lastTap = { rowId: null, at: 0 };
        openedAt = at;
        return true;
      }
      lastTap = { rowId, at };
      return false;
    },
    openedJustNow() {
      return now() - openedAt < DBLCLICK_AFTER_TAP_MS;
    },
  };
}
